import { useToast } from '@chakra-ui/react';
import React from 'react';

import { finleyAssert, finleyBuffer } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';
import type { TapeBuilderNodeAbstract } from '@finley-technologies/tape-builder';

import { FileUploadButton } from './FileUploadButton';
import { isQAFileExtension, useQAContext } from './QAContext';
import { successToastConfig } from 'packages/common-frontend/constants';

type FileUploadPanelProps = {
  tapeBuilderNode: TapeBuilderNodeAbstract;
};
export const FileUploadPanel = ({ tapeBuilderNode }: FileUploadPanelProps) => {
  const nodeId = tapeBuilderNode.metadata.tapeBuilderNodeId;

  const toast = useToast();

  // QAFileExtensionIterables is readonly.
  const allowedExtensions = [...Util.SupportedFileExtensionIterable];

  const { setNodeBuffer } = useQAContext();
  return (
    <FileUploadButton
      allowedExtensions={allowedExtensions}
      buttonText="Upload Tape"
      handleFile={(arrayBuffer: ArrayBuffer, fileName: string) => {
        // get extension from filename.
        const extension = fileName.split('.').pop() || 'csv';
        finleyAssert(
          isQAFileExtension(extension),
          `Invalid file extension:${extension}. Allowed extensions are ${Util.SupportedFileExtensionIterable.join(
            ', ',
          )}`,
        );
        const uint8View = finleyBuffer.fromArrayBuffer(arrayBuffer);
        setNodeBuffer(nodeId, uint8View, extension); // extension is used for download.
        toast({
          ...successToastConfig,
          description:
            'File uploaded successfully. Please proceed to next node.',
        });
      }}
    />
  );
};
